export default class RectifierModel {
  constructor() {
    this.productId = '';
    // vendor 0 光陽 1三陽 … 數字可以新增
    this.vendor = 0;
    // 商品類型 0: 整流器 1:ECU
    this.type = 0;
    // 車名
    this.carName = '';
    this.cc = '';
    // 整流器型號
    this.id = '';
    // 機種代號
    this.generalNumber = '';
    // 0 街道版/1 升級版
    this.category = 0;
    // 備註
    this.comment = '';
    this.imageList = [];
    // for 整流器種類
    this.kind = '';

    // for ecu
    // 口徑
    this.caliber = '';
    this.groupId = ''; // ecu群組groupId

    // 引擎號碼(英文部分)
    this.engineNumber = '';

    // for 光陽
    // 規格
    this.specification = '';
    // for 三陽
    // 引擎號碼起始編號
    this.beginEngineNumber = '';
    // 引擎號碼結束編號
    this.endEngineNumber = '';
  }
}



// WEBPACK FOOTER //
// ./src/models/RectifierModel.js